import { render, staticRenderFns } from "./SeedDetailsForm.vue?vue&type=template&id=6f3a237f&scoped=true&"
import script from "./SeedDetailsForm.vue?vue&type=script&lang=js&"
export * from "./SeedDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./SeedDetailsForm.vue?vue&type=style&index=0&id=6f3a237f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3a237f",
  null
  
)

export default component.exports